import Layout from "components/layout/Layout";
import { Link } from "react-router-dom";

export default function Help() {
  return (
    <>
      <Layout
        headerStyle={1}
        footerStyle={1}
        breadcrumbTitle={
          <>
            👋 Hello, How can <span>we help?</span>
          </>
        }
      >
        <div>
          <section className="job-details-area pb-150">
            <div className="container">
              <div className="row">
                <div className="col-lg-10">
                  <div className="job-details-content">
                    <div className="job-qualifications">
                      <p className="info-one">
                        We are here to assist you at every stage of your fitness and wellness journey. Explore our Help Center for guides, connect with our community for advice, or contact us directly for personalized support. Your success is our priority, and we're here to ensure a seamless experience with BodyLytiX.
                      </p>
                    </div>
                    <div className="job-details-list-wrap">
                      <h2 className="title-two">
                        How We Support You
                      </h2>
                      <ol>
                        <li>
                          <div>Help Center</div>
                          Our Help Center is your go-to resource for answers to common questions and step-by-step guides. From syncing your devices to understanding your fitness insights, you’ll find all the information you need to navigate BodyLytiX with confidence.
                        </li>
                        <li>
                          <div>
                            Visit the FAQs Section 
                          </div>
                          Need help while using the app? Access our in-app support feature to chat with our support team or search for relevant articles directly within BodyLytiX.
                        </li>
                        <li>
                          <div>
                            Contact Us 
                          </div>
                          Can’t find what you’re looking for? Our dedicated support team is here to assist you. Reach out via email or our contact form, and we’ll respond as quickly as possible.
                          <div>
                            <strong>
                              Email: 
                            </strong>
                            <span> <a href="mailto:support@bodylytix.ai">
                              support@bodylytix.ai
                            </a>
                            </span>
                          </div>
                          <div>
                            <strong>Contact Form: </strong>
                            <span>
                              <Link to="/contact">
                                contact us
                              </Link>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div>
                            Community Support
                          </div>
                          Join our community forums to connect with other users, share tips, and get advice. Engage with a network of like-minded fitness enthusiasts and learn from their experiences.
                        </li>
                      </ol>
                    </div>
                    <div className="job-details-list-wrap">
                      <h2 className="title-two">
                        Common Support Topics
                      </h2>
                      <ul>
                        <li>
                          <strong>Getting Started: </strong>
                          Learn how to set up your account, connect your devices, and begin tracking your
                        </li>
                        <li>
                          <strong>Device Syncing: </strong>
                          Troubleshoot common issues with Garmin, Apple Health, and other integrations.
                        </li>
                        <li>
                          <strong>Using AI Coaches: </strong>
                          Discover how to personalize your training, create your own coaches, and explore shared coaches.
                        </li>
                        <li>
                          <strong>Account Management: </strong>
                          Manage your settings, privacy preferences, and subscription options.
                        </li>
                      </ul>
                    </div>

                    <div className="job-details-list-wrap">
                      <h2 className="title-two">
                        Our Promise
                      </h2>
                      <p>At BodyLytiX, your success is our priority. We aim to deliver not just a powerful fitness and wellness platform but also a seamless, supportive experience. If there’s anything you need, don’t hesitate to reach out. Your feedback helps us grow, innovate, and provide the best service possible.</p>
                      <p>We’re here for you every step of the way. Let us know how we can help!</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* faq-area */}
          {/* <section className="faq-area-two pb-130">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="problem-search-wrap text-center">
                    <form action="#">
                      <div className="form-grp">
                        <label htmlFor="search">
                          <i className="far fa-search" />
                        </label>
                        <input
                          type="text"
                          id="search"
                          placeholder="Write a question or problem"
                        />
                        <button type="submit" className="gradient-btn">
                          search
                        </button>
                      </div>
                      <span>
                        Or choose a category to quickly find the help you need
                      </span>
                    </form>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="faq-tab-wrap">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                      <li className="nav-item" onClick={() => handleOnClick(1)}>
                        <button
                          className={
                            activeIndex == 1 ? "nav-link active" : "nav-link"
                          }
                        >
                          <img src="assets/img/icon/faq_icon01.svg" alt="" />
                          Getting Started
                        </button>
                      </li>
                      <li className="nav-item" onClick={() => handleOnClick(2)}>
                        <button
                          className={
                            activeIndex == 2 ? "nav-link active" : "nav-link"
                          }
                        >
                          <img src="assets/img/icon/faq_icon02.svg" alt="" />
                          pricing Plans
                        </button>
                      </li>
                      <li className="nav-item" onClick={() => handleOnClick(3)}>
                        <button
                          className={
                            activeIndex == 3 ? "nav-link active" : "nav-link"
                          }
                        >
                          <img src="assets/img/icon/faq_icon03.svg" alt="" />
                          Usage Guides
                        </button>
                      </li>
                      <li className="nav-item" onClick={() => handleOnClick(4)}>
                        <button
                          className={
                            activeIndex == 4 ? "nav-link active" : "nav-link"
                          }
                        >
                          <img src="assets/img/icon/faq_icon04.svg" alt="" />
                          Sales Question
                        </button>
                      </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                      <div
                        className={
                          activeIndex == 1
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                      >
                        <div className="faq-wrap">
                          <div className="accordion">
                            {FAQ_ARR.map((faq) => (
                              <div
                                className={
                                  isActive.key === faq?.key
                                    ? "accordion-item active"
                                    : "accordion-item"
                                }
                                key={faq?.key}
                              >
                                <h2 className="accordion-header">
                                  <button
                                    className={
                                      isActive.key === faq?.key
                                        ? "accordion-button"
                                        : "accordion-button collapsed"
                                    }
                                    type="button"
                                    onClick={() => handleToggle(faq?.key)}
                                  >
                                    {faq?.title}
                                  </button>
                                </h2>
                                <Collapse isOpened={isActive.key === faq?.key}>
                                  <div
                                    className={
                                      isActive.key === faq?.key
                                        ? "accordion-collapse collapse show"
                                        : "accordion-collapse collapse"
                                    }
                                  >
                                    <div className="accordion-body">
                                      <p>{faq?.content}</p>
                                    </div>
                                  </div>
                                </Collapse>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          activeIndex == 2
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                      >
                        <div className="faq-wrap">
                          <div className="accordion">
                            {FAQ_ARR.map((faq) => (
                              <div
                                className={
                                  isActive.key === faq?.key
                                    ? "accordion-item active"
                                    : "accordion-item"
                                }
                                key={faq?.key}
                              >
                                <h2 className="accordion-header">
                                  <button
                                    className={
                                      isActive.key === faq?.key
                                        ? "accordion-button"
                                        : "accordion-button collapsed"
                                    }
                                    type="button"
                                    onClick={() => handleToggle(faq?.key)}
                                  >
                                    {faq?.title}
                                  </button>
                                </h2>
                                <Collapse isOpened={isActive.key === faq?.key}>
                                  <div
                                    className={
                                      isActive.key === faq?.key
                                        ? "accordion-collapse collapse show"
                                        : "accordion-collapse collapse"
                                    }
                                  >
                                    <div className="accordion-body">
                                      <p>{faq?.content}</p>
                                    </div>
                                  </div>
                                </Collapse>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          activeIndex == 3
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                      >
                        <div className="faq-wrap">
                          <div className="accordion">
                            {FAQ_ARR.map((faq) => (
                              <div
                                className={
                                  isActive.key === faq?.key
                                    ? "accordion-item active"
                                    : "accordion-item"
                                }
                                key={faq?.key}
                              >
                                <h2 className="accordion-header">
                                  <button
                                    className={
                                      isActive.key === faq?.key
                                        ? "accordion-button"
                                        : "accordion-button collapsed"
                                    }
                                    type="button"
                                    onClick={() => handleToggle(faq?.key)}
                                  >
                                    {faq?.title}
                                  </button>
                                </h2>
                                <Collapse isOpened={isActive.key === faq?.key}>
                                  <div
                                    className={
                                      isActive.key === faq?.key
                                        ? "accordion-collapse collapse show"
                                        : "accordion-collapse collapse"
                                    }
                                  >
                                    <div className="accordion-body">
                                      <p>{faq?.content}</p>
                                    </div>
                                  </div>
                                </Collapse>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          activeIndex == 4
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                      >
                        <div className="faq-wrap">
                          <div className="accordion">
                            {FAQ_ARR.map((faq) => (
                              <div
                                className={
                                  isActive.key === faq?.key
                                    ? "accordion-item active"
                                    : "accordion-item"
                                }
                                key={faq?.key}
                              >
                                <h2 className="accordion-header">
                                  <button
                                    className={
                                      isActive.key === faq?.key
                                        ? "accordion-button"
                                        : "accordion-button collapsed"
                                    }
                                    type="button"
                                    onClick={() => handleToggle(faq?.key)}
                                  >
                                    {faq?.title}
                                  </button>
                                </h2>
                                <Collapse isOpened={isActive.key === faq?.key}>
                                  <div
                                    className={
                                      isActive.key === faq?.key
                                        ? "accordion-collapse collapse show"
                                        : "accordion-collapse collapse"
                                    }
                                  >
                                    <div className="accordion-body">
                                      <p>{faq?.content}</p>
                                    </div>
                                  </div>
                                </Collapse>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}
          {/* faq-area-end */}
          {/* help-area */}
          {/* <section className="help-area pb-110">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-8">
                  <div className="help-title text-center mb-75">
                    <h2 className="title">
                      You still have a <span>question?</span>
                    </h2>
                    <p>
                      If you cannot find the answer to your question in our FAQ,
                      you can always contact us. We will answer you shortly!
                    </p>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-xl-9 col-lg-10">
                  <div className="help-center-wrap">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="help-center-item">
                          <div className="icon">
                            <img src="assets/img/icon/help_icon01.svg" alt="" />
                          </div>
                          <div className="content">
                            <Link to="tel:0123456789">+(1) 123 656 7865</Link>
                            <p>We are always happy to help.</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="help-center-item">
                          <div className="icon">
                            <img src="assets/img/icon/help_icon02.svg" alt="" />
                          </div>
                          <div className="content">
                            <Link to="mailto:dex.aiinfotive@.com">
                              support@bodylytix.ai
                            </Link>
                            <p>The best way to get answer faster.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}
          {/* help-area-end */}
        </div>
      </Layout>
    </>
  );
}
